<!-- Loading -->
@if (isLoading) {
  <div class="flex justify-center py-10">
    <span class="loading loading-spinner loading-lg" aria-label="Loading"></span>
  </div>
}

@if (!isLoading) {

  @if (errorMsg) {
    <ui-alert [variant]="'error'" [className]="'mb-4'">
      {{ errorMsg }}
    </ui-alert>
  }

  @if (finalized) {
    @if (finalizedDecision === 'accept') {
      <ui-alert [variant]="'success'" [className]="'mb-4'">
        Invitation accepted. Welcome to <strong>{{ preview?.household_name }}</strong>!
      </ui-alert>
    }

    @if (finalizedDecision === 'reject') {
      <ui-alert [variant]="'info'" [className]="'mb-4'">
        Invitation rejected. You won’t be added to <strong>{{ preview?.household_name }}</strong>.
      </ui-alert>
    }
  }

  @if (alreadyProcessed && !errorMsg) {
    <ui-alert [variant]="'warning'" [className]="'mb-4'">
      This invitation was already processed.
    </ui-alert>
  }

  @if (householdsLoaded) {
    <div class="mx-auto max-w-5xl px-4 py-10">
      <div class="text-center mb-8">
        <h2 class="text-2xl font-semibold">Select a Household</h2>
        <p class="text-base-content/60 mt-1">
          Click a card to set your default household.
        </p>
      </div>

      <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6">
        @for (h of households; track h.id) {
          <button
            type="button"
            class="text-left focus-visible:outline-none"
            (click)="selectHousehold(h)"
            [disabled]="isLoading"
            [attr.aria-pressed]="selectedHouseholdId === h.id"
            [attr.aria-label]="'Set ' + h.name + ' as default household'"
          >
            <div
              class="card bg-base-100 border border-base-300 shadow-md transition-all duration-200 hover:-translate-y-0.5 hover:shadow-lg focus-visible:ring-2 focus-visible:ring-primary cursor-pointer"
              [class.ring-2]="selectedHouseholdId === h.id"
              [class.ring-primary]="selectedHouseholdId === h.id"
              [class.ring-offset-2]="selectedHouseholdId === h.id"
              [class.ring-offset-base-100]="selectedHouseholdId === h.id"
              [class.opacity-60]="isLoading"
              [class.pointer-events-none]="isLoading"
            >
              <div class="card-body items-center text-center min-h-40 justify-center">
                <div class="flex flex-wrap items-center justify-center gap-2">
                  <h3 class="card-title text-lg md:text-xl">{{ h.name }}</h3>

                  @if (preview?.household_name === h.name) {
                    <ui-badge [variant]="'success'">
                      New
                    </ui-badge>
                  }

                  @if (selectedHouseholdId === h.id) {
                    <div class="badge badge-outline">Default</div>
                  }
                </div>

                @if (selectedHouseholdId !== h.id) {
                  <div class="text-sm text-base-content/60 mt-3">Set as default</div>
                }
              </div>
            </div>
          </button>
        }
      </div>
    </div>
  }
}
